import React from "react";

import {
  Column,
  Columns,
  Heading,
  Hidden,
  Section,
  Stack,
  Text,
} from "@origin-digital/ods-core";

import content from "./content.json";

import { cloudinary } from "src/consts";

export const HowSection: React.FC = () => (
  <Section>
    <Hidden above="sm">
      <Stack space="large">
        <Heading variant="h2">{content.heading}</Heading>
        {content.sections.map((section, index) => (
          <Columns key={`how-section-mobile-${index}`}>
            <Column>
              <Text> {section.text}</Text>
            </Column>
            <Column width="content">
              <img
                src={`${cloudinary}${section.icon}`}
                height="96px"
                width="96px"
              />
            </Column>
          </Columns>
        ))}
      </Stack>
    </Hidden>

    <Hidden below="md">
      <Stack space="xxlarge">
        <Heading variant="h2" align="center">
          {content.heading}
        </Heading>
        <Columns>
          {content.sections.map((section, index) => (
            <Column width="1/3" key={`how-section-${index}`}>
              <Stack alignX="center">
                <Hidden below="lg">
                  <img
                    src={`${cloudinary}${section.icon}`}
                    height="172px"
                    width="172px"
                  />
                </Hidden>
                <Hidden above="md">
                  <img
                    src={`${cloudinary}${section.icon}`}
                    height="128px"
                    width="128px"
                  />
                </Hidden>
                <Text align="center">{section.text}</Text>
              </Stack>
            </Column>
          ))}
        </Columns>
      </Stack>
    </Hidden>
  </Section>
);
